module.exports = __webpack_public_path__ + "baf03d501af7a8f7198096092db2057f.MP3";